import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { QuotedText } from '../../components/QuotedText/QuotedText';
import {
  RepliedMessage,
  TRepliedMessageTheme,
} from '../../components/RepliedMessage/RepliedMessage';

interface IQuotedMessageProps {
  message?: ChatMessage;
  className?: string;
  theme?: TRepliedMessageTheme;
}

export const QuotedMessage: FC<IQuotedMessageProps> = observer(({ message, className, theme }) => {
  if (message?.repliedMessage) {
    return (
      <RepliedMessage
        preventInteraction={message.group?.isSchedule}
        message={message.repliedMessage}
        className={className}
        theme={theme}
      />
    );
  }
  if (message?.quote) {
    return (
      <QuotedText
        parentMessageId={message.id}
        quote={message.quote}
        className={className}
        theme={theme}
      />
    );
  }
  return null;
});
